import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "./Footer";

const Connect = () => {
  const pageStyle = {
    minHeight: "100vh",
    background: "#fff",
    fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
    maxWidth: "100%",
  };

  const titleStyle = {
    fontSize: "40px",
    fontWeight: 400,
    color: "#111",
    marginBottom: "1.5rem",
    textAlign: "left",
  };

  const dotStyle = {
    color: "#fef200",
    fontSize: "1.1em",
  };

  const addressStyle = {
    color: "#111",
    fontSize: "1.1rem",
    marginBottom: "2.2rem",
    lineHeight: 1.5,
  };

  const dividerStyle = {
    border: "none",
    borderTop: "1.5px solid #222",
    margin: "2.5rem 0 2rem 0",
  };

  const socialsBlockStyle = {
    marginTop: "1.5rem",
  };

  const socialsLabelStyle = {
    fontSize: "1.1rem",
    color: "#111",
    marginBottom: "0.7rem",
  };

  const socialsStyle = {
    display: "flex",
    gap: "1.2rem",
    marginBottom: "1.2rem",
  };

  const socialIconStyle = {
    cursor: "pointer",
    transition: "color 0.2s, transform 0.2s",
    color: "#111",
    textDecoration: "none",
    display: "flex",
  };

  const emailStyle = {
    fontSize: "1.1rem",
    color: "#111",
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={pageStyle}>
      <Navbar />
      <div className="homeegram-content">
        <h1 style={titleStyle}>
          Connect Us<span style={dotStyle}>.</span>
        </h1>
        <div style={addressStyle}>
          Homeeera Platforms Pvt. Ltd
          <br />
          NH 544, First Floor, G.I Square
          <br />
          Above Lenskart, Kothakulangara,
          <br /> Angamaly, Kerala, India <br />
          PIN : 683576
        </div>
        <hr style={dividerStyle} />
        <div style={socialsBlockStyle}>
          <div style={socialsLabelStyle}>Connect Homeeera</div>
          <div style={socialsStyle}>
            <a href="#" style={socialIconStyle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
              </svg>
            </a>
            <a href="#" style={socialIconStyle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4h16v16H4z"></path>
                <path d="M4 12l6.5 6.5M12 8l-8 8M12 4l8 8-8 8"></path>
              </svg>
            </a>
            <a href="#" style={socialIconStyle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
            </a>
            <a href="#" style={socialIconStyle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
              </svg>
            </a>
            <a href="#" style={socialIconStyle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                <rect x="2" y="9" width="4" height="12"></rect>
                <circle cx="4" cy="4" r="2"></circle>
              </svg>
            </a>
            <a href="#" style={socialIconStyle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
                <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
              </svg>
            </a>
          </div>
          <div
            onClick={() =>
              (window.location.href = "mailto:connect@homeeera.com")
            }
            style={emailStyle}
          >
            Contact : connect@homeeera.com
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Connect;
